import UnforeseenReasonsCellRenderer from 'components/pages/history/UnforeseenReasonsCellRenderer';
import { HistoryRow } from './History';
import { DeclarationTypes } from 'pages/SubmissionFormWizard/SubmissionFormWizard';

const renderReasonForAbsence = (row: HistoryRow) => {
    if (row?.reasonForAbsence === 'No submissions data found') {
        return (
            <div
                style={{
                    textAlign: 'center',
                    width: '100%',
                }}
            >
                {row.reasonForAbsence}
            </div>
        );
    } else if (row?.declarationType === DeclarationTypes.Planned) {
        return (
            <div
                style={{
                    width: '100%',
                }}
            >
                {row.reasonForAbsence}
            </div>
        );
    } else if (row) {
        return (
            <UnforeseenReasonsCellRenderer row={row} field="reasonForAbsence" />
        );
    }
};

export default renderReasonForAbsence;
